import * as React from 'react';
import { IconList as IconList$1 } from '@grandvisionhq/content';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import { getUrl } from '../../utils/get-url.js';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsIconList = ({ page , content , theme  })=>{
    const { iconLinkCompoundList =[] , title  } = content;
    const items = React.useMemo(()=>{
        return iconLinkCompoundList.map(({ icon , link  })=>({
                icon,
                url: getUrl(link.url || '', page),
                label: link.label
            })
        );
    }, [
        iconLinkCompoundList,
        page
    ]);
    return /*#__PURE__*/ React.createElement(IconList$1, {
        items: items,
        title: title,
        theme: theme
    });
};
var IconList = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsIconList);

export { CmsIconList, IconList as default };
//# sourceMappingURL=IconList.js.map
